function relDate(offsetDays) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return d.toISOString().slice(0, 10);
}

function daysFrom(offsetDays) {
  return offsetDays > 0 ? offsetDays : 0;
}

export const sampleLocations = [
  { id: 'sample-ramstein', name: 'Ramstein / Kaiserslautern' },
  { id: 'sample-stuttgart', name: 'Stuttgart' },
  { id: 'sample-vilseck', name: 'Vilseck / Grafenwoehr' },
];

export const samplePricingPackages = {
  RECON: {
    name: 'Recon',
    tagline: 'Launch with confidence',
    price_monthly: 0,
    price_yearly: 0,
    description: 'A solid starting point for owners who need a premium but lean public presence.',
    popular: false,
    features: {
      max_listings: 1,
      photos_per_listing: 12,
      virtual_tour: false,
      weekly_reports: false,
      priority_placement: false,
      concierge_support: false,
      response_time_guarantee: false,
      custom_branding: false,
      api_access: false,
    },
    comparison: { industry_avg_price: 49, savings: '€588 / year' },
  },
  BASECAMP: {
    name: 'Basecamp',
    tagline: 'For serious owner-operators',
    price_monthly: 79,
    price_yearly: 790,
    description: 'Best for owners who want stronger placement, more photos, and better conversion visibility.',
    popular: true,
    features: {
      max_listings: 3,
      photos_per_listing: 24,
      virtual_tour: true,
      weekly_reports: true,
      priority_placement: true,
      concierge_support: false,
      response_time_guarantee: '24h',
      custom_branding: false,
      api_access: false,
    },
    comparison: { industry_avg_price: 149, savings: '€840 / year' },
  },
  COMMAND: {
    name: 'Command',
    tagline: 'Built for premium relocation operators',
    price_monthly: 149,
    price_yearly: 1490,
    description: 'For high-trust owners and operators who need stronger brand control and premium positioning.',
    popular: false,
    features: {
      max_listings: 10,
      photos_per_listing: 40,
      virtual_tour: true,
      weekly_reports: true,
      priority_placement: true,
      concierge_support: true,
      response_time_guarantee: '12h',
      custom_branding: true,
      api_access: false,
    },
    comparison: { industry_avg_price: 299, savings: '€1,800 / year' },
  },
  FORTRESS: {
    name: 'Fortress',
    tagline: 'Enterprise relocation control',
    price_monthly: 349,
    price_yearly: 3490,
    description: 'For portfolio owners, agencies, and serious operators who need scale, trust, and operational control.',
    popular: false,
    features: {
      max_listings: 'unlimited',
      photos_per_listing: 'unlimited',
      virtual_tour: true,
      weekly_reports: true,
      priority_placement: true,
      concierge_support: true,
      response_time_guarantee: '4h',
      custom_branding: true,
      api_access: true,
    },
    comparison: { industry_avg_price: 599, savings: '€3,000 / year' },
  },
};

export const sampleIndustryComparison = {
  trust_factors: [
    {
      title: 'Germany-first relocation focus',
      description: 'Public inventory, trust signals, and pricing are tailored to PCS/TLA decisions, not tourist stays.',
    },
    {
      title: 'Clear monthly cost visibility',
      description: 'Owners can surface known monthly totals and move-in costs instead of forcing families to guess.',
    },
    {
      title: 'Timing and availability signals',
      description: 'Families can compare ready-now homes against listings opening in the next 30 to 90 days.',
    },
    {
      title: 'Premium owner presentation',
      description: 'Verified profiles, walkthrough requests, and structured listing detail raise trust before inquiry.',
    },
    {
      title: 'Relocation-fit search',
      description: 'Search and cards emphasize decision quality, not generic scrolling and vanity browsing.',
    },
    {
      title: 'Operational control for owners',
      description: 'Owners can manage listing quality, positioning, and public presentation without agency friction.',
    },
  ],
  vs_airbnb: {
    their_fee: '12% to 18% + guest fees',
    our_fee: 'Flat subscription, no booking commission',
    annual_savings: '€1,000+ for active owners',
  },
  vs_traditional: {
    their_fee: 'One month rent or long agency contracts',
    our_fee: 'Predictable monthly operating cost',
    annual_savings: 'Stronger margin retention and faster control',
  },
};

const _listingTranslations = {
  'sample-ramstein-command-home': {
    de: { title: 'Familien-Kommandeurshaus nahe Ramstein', amenities: ['Eingezäunter Garten', 'Garage', 'Schnelles Internet', 'Waschmaschine & Trockner'] },
    es: { title: 'Casa familiar de nivel comando cerca de Ramstein', amenities: ['Jardín cercado', 'Garaje', 'Internet de alta velocidad', 'Lavadora y secadora'] },
  },
  'sample-stuttgart-officer-flat': {
    de: { title: 'Modernes Stuttgarter Executive-Apartment mit ÖPNV-Anschluss', amenities: ['Aufzug', 'Nahverkehr', 'Balkon', 'Arbeitsplatz'] },
    es: { title: 'Moderno apartamento ejecutivo en Stuttgart con acceso al transporte', amenities: ['Ascensor', 'Transporte cercano', 'Balcón', 'Espacio de trabajo'] },
  },
  'sample-vilseck-ready-townhome': {
    de: { title: 'Sofort bezugsfertiges Stadthaus nahe Vilseck-Tor', amenities: ['Terrasse', 'Parkplatz', 'Abstellraum', 'Schneller Weg zur Basis'] },
    es: { title: 'Casa adosada lista para entrar cerca de la puerta de Vilseck', amenities: ['Patio', 'Aparcamiento', 'Trastero', 'Ruta rápida a la base'] },
  },
  'sample-ramstein-reserved-apt': {
    de: { title: 'Ramstein 2-Zi. reserviert — Einzug in 5 Wochen', amenities: ['Balkon', 'Spülmaschine', 'Nahverkehr', 'Ruhige Lage'] },
    es: { title: 'Ramstein 2 hab. reservado — disponible en 5 semanas', amenities: ['Balcón', 'Lavavajillas', 'Transporte cercano', 'Barrio tranquilo'] },
  },
  'sample-stuttgart-large-family': {
    de: { title: 'Stuttgarter 3-Zi. Familienhaus — Einzug in 2 Wochen', amenities: ['Garten', 'Garage', 'Schnelles Internet', 'Waschmaschine & Trockner', 'Kellerraum'] },
    es: { title: 'Casa familiar de 3 hab. en Stuttgart — disponible en 2 semanas', amenities: ['Jardín', 'Garaje', 'Internet de alta velocidad', 'Lavadora y secadora', 'Trastero'] },
  },
  'sample-vilseck-studio-available': {
    de: { title: 'Vilseck 1-Zi. Wohnung — sofort verfügbar, Einzel/Paar', amenities: ['Kompaktküche', 'Schnelles WLAN', 'Straßenparkplatz'] },
    es: { title: 'Vilseck apartamento 1 hab. — disponible ahora, individual/pareja', amenities: ['Cocina compacta', 'WiFi rápido', 'Aparcamiento en calle'] },
  },
};

export function getSampleListings(locale = 'en') {
  if (locale === 'en') return sampleListings;
  return sampleListings.map((listing) => {
    const tr = _listingTranslations[listing.id]?.[locale];
    if (!tr) return listing;
    return { ...listing, title: tr.title, amenities: tr.amenities };
  });
}

export const sampleListings = [
  {
    id: 'sample-ramstein-command-home',
    title: 'Command-Level Family Home Near Ramstein',
    owner_id: 'sample-owner-1',
    owner_name: 'Ramstein Relocation Group',
    location_id: 'sample-ramstein',
    location_name: 'Ramstein / Kaiserslautern',
    location_lat: 49.4401,
    location_lng: 7.7491,
    location_coordinate_source: 'LOCATION_CENTER',
    region: 'Rhineland-Palatinate',
    nearby_bases: ['Ramstein AB', 'Landstuhl'],
    hero_photo_url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=800&fit=crop',
    photos: [
      { url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=800&fit=crop', category: 'EXTERIOR' },
      { url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop', category: 'LIVING_ROOM' },
      { url: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=1200&h=800&fit=crop', category: 'BEDROOM' },
    ],
    photo_count: 18,
    bedrooms: 4,
    bathrooms: 2,
    sqm: 172,
    tla_status: 'eligible',
    tla_eligible: true,
    availability_status: 'AVAILABLE',
    available_from: relDate(-10),
    days_until_available: 0,
    availability_confidence: 'HIGH',
    last_confirmed_at: relDate(-2),
    is_early_access: false,
    auto_deactivated: false,
    amenities: ['Fenced yard', 'Garage', 'High-speed internet', 'Washer / dryer'],
    avg_rating: 4.9,
    review_count: 14,
    description: 'Premium family-ready home designed for PCS arrivals who need parking, storage, fast commute access, and a clean move-in story. Strong for families who want a quiet neighborhood with direct access toward Ramstein and Landstuhl.',
    property_type: 'Furnished detached house',
    floor: 'Ground + first floor',
    year_built: 2019,
    last_renovated: 2025,
    kitchen_type: 'Full family kitchen',
    heating_type: 'Central heating',
    energy_rating: 'B',
    parking_type: 'Private garage',
    parking_spaces: 2,
    parking_included: true,
    pets_allowed: true,
    pet_policy: 'Dogs considered with prior approval',
    min_stay_days: 30,
    max_stay_days: 365,
    base_amount: 2450,
    total_monthly_cost: 2790,
    utilities_cost: 210,
    electricity_cost: 70,
    internet_cost: 60,
    parking_cost: 0,
    security_deposit: 1800,
    cleaning_fee: 150,
    deposit_months: 1,
    internet_speed: 'Fiber-ready internet',
    internet_included: false,
    electricity_included: false,
    live_walkthrough_enabled: true,
    virtual_tour_url: 'https://example.com/sample-tour/ramstein-command-home',
  },
  {
    id: 'sample-stuttgart-officer-flat',
    title: 'Modern Stuttgart Executive Flat with Transit Access',
    owner_id: 'sample-owner-2',
    owner_name: 'Stuttgart PCS Homes',
    location_id: 'sample-stuttgart',
    location_name: 'Stuttgart',
    location_lat: 48.7758,
    location_lng: 9.1829,
    location_coordinate_source: 'LOCATION_CENTER',
    region: 'Baden-Wuerttemberg',
    nearby_bases: ['Patch Barracks', 'Panzer Kaserne'],
    hero_photo_url: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop',
    photos: [
      { url: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop', category: 'LIVING_ROOM' },
      { url: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=1200&h=800&fit=crop', category: 'KITCHEN' },
      { url: 'https://images.unsplash.com/photo-1505692952047-1a78307da8f2?w=1200&h=800&fit=crop', category: 'BEDROOM' },
    ],
    photo_count: 12,
    bedrooms: 2,
    bathrooms: 1,
    sqm: 94,
    tla_status: 'eligible',
    tla_eligible: true,
    availability_status: 'COMING_SOON',
    available_from: relDate(22),
    days_until_available: daysFrom(22),
    availability_confidence: 'MEDIUM',
    last_confirmed_at: relDate(-4),
    is_early_access: true,
    auto_deactivated: false,
    amenities: ['Elevator', 'Transit nearby', 'Balcony', 'Dedicated workspace'],
    avg_rating: 4.7,
    review_count: 8,
    description: 'High-trust furnished flat for shorter Stuttgart transition periods. Strong option for professionals who need a polished base close to transport, with lower maintenance than a large family home.',
    property_type: 'Furnished apartment',
    floor: '3rd floor',
    year_built: 2016,
    last_renovated: 2024,
    kitchen_type: 'Open-plan kitchen',
    heating_type: 'District heating',
    energy_rating: 'A',
    parking_type: 'Underground reserved spot',
    parking_spaces: 1,
    parking_included: false,
    parking_cost: 95,
    pets_allowed: false,
    pet_policy: 'No pets',
    min_stay_days: 30,
    max_stay_days: 270,
    base_amount: 1990,
    total_monthly_cost: 2325,
    utilities_cost: 180,
    electricity_cost: 55,
    internet_cost: 45,
    security_deposit: 1500,
    cleaning_fee: 120,
    deposit_months: 1,
    internet_speed: 'Business-grade WiFi',
    internet_included: false,
    electricity_included: false,
    live_walkthrough_enabled: true,
    virtual_tour_url: '',
  },
  {
    id: 'sample-vilseck-ready-townhome',
    title: 'Ready-Now Townhome Near Vilseck Gate',
    owner_id: 'sample-owner-3',
    owner_name: 'Grafenwoehr Area Rentals',
    location_id: 'sample-vilseck',
    location_name: 'Vilseck / Grafenwoehr',
    location_lat: 49.6136,
    location_lng: 11.8018,
    location_coordinate_source: 'LOCATION_CENTER',
    region: 'Bavaria',
    nearby_bases: ['Rose Barracks', 'Grafenwoehr Training Area'],
    hero_photo_url: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&h=800&fit=crop',
    photos: [
      { url: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&h=800&fit=crop', category: 'EXTERIOR' },
      { url: 'https://images.unsplash.com/photo-1494526585095-c41746248156?w=1200&h=800&fit=crop', category: 'LIVING_ROOM' },
      { url: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop', category: 'BEDROOM' },
    ],
    photo_count: 15,
    bedrooms: 3,
    bathrooms: 2,
    sqm: 138,
    tla_status: 'eligible',
    tla_eligible: true,
    availability_status: 'AVAILABLE',
    available_from: relDate(-5),
    days_until_available: 0,
    availability_confidence: 'HIGH',
    last_confirmed_at: relDate(-1),
    is_early_access: false,
    auto_deactivated: false,
    amenities: ['Patio', 'Parking', 'Storage room', 'Fast route to base'],
    avg_rating: 4.8,
    review_count: 11,
    description: 'A ready-now family townhome built for quick PCS landings. Balanced rent, dependable commute, and enough space for a family that wants immediate occupancy without sacrificing presentation quality.',
    property_type: 'Townhome',
    floor: 'Two-story',
    year_built: 2014,
    last_renovated: 2023,
    kitchen_type: 'Modern full kitchen',
    heating_type: 'Gas heating',
    energy_rating: 'B',
    parking_type: 'Driveway + private space',
    parking_spaces: 2,
    parking_included: true,
    pets_allowed: true,
    pet_policy: 'Small pets welcome with approval',
    min_stay_days: 30,
    max_stay_days: 365,
    base_amount: 2190,
    total_monthly_cost: 2495,
    utilities_cost: 190,
    electricity_cost: 55,
    internet_cost: 60,
    security_deposit: 1600,
    cleaning_fee: 140,
    deposit_months: 1,
    internet_speed: 'Cable internet',
    internet_included: false,
    electricity_included: false,
    live_walkthrough_enabled: true,
    virtual_tour_url: '',
  },
  {
    id: 'sample-ramstein-reserved-apt',
    title: 'Ramstein 2BR Reserved — Opens in 5 Weeks',
    owner_id: 'sample-owner-4',
    owner_name: 'K-Town Family Rentals',
    location_id: 'sample-ramstein',
    location_name: 'Ramstein / Kaiserslautern',
    location_lat: 49.4401,
    location_lng: 7.7491,
    location_coordinate_source: 'LOCATION_CENTER',
    region: 'Rhineland-Palatinate',
    nearby_bases: ['Ramstein AB', 'Landstuhl'],
    hero_photo_url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&h=800&fit=crop',
    photos: [
      { url: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&h=800&fit=crop', category: 'LIVING_ROOM' },
      { url: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=1200&h=800&fit=crop', category: 'KITCHEN' },
      { url: 'https://images.unsplash.com/photo-1505692952047-1a78307da8f2?w=1200&h=800&fit=crop', category: 'BEDROOM' },
    ],
    photo_count: 10,
    bedrooms: 2,
    bathrooms: 1,
    sqm: 86,
    tla_status: 'eligible',
    tla_eligible: true,
    availability_status: 'RESERVED',
    available_from: relDate(38),
    booked_until: relDate(37),
    days_until_available: daysFrom(38),
    availability_confidence: 'HIGH',
    last_confirmed_at: relDate(-1),
    is_early_access: false,
    auto_deactivated: false,
    amenities: ['Balcony', 'Dishwasher', 'Transit nearby', 'Quiet neighborhood'],
    avg_rating: 4.6,
    review_count: 5,
    description: 'Well-maintained furnished apartment in central Kaiserslautern. Currently reserved — previous tenant handoff confirmed. Accepting inquiries from families arriving 5+ weeks out. Early paperwork welcome.',
    property_type: 'Furnished apartment',
    floor: '2nd floor',
    year_built: 2012,
    last_renovated: 2023,
    kitchen_type: 'Full kitchen',
    heating_type: 'Gas heating',
    energy_rating: 'C',
    parking_type: 'Shared courtyard parking',
    parking_spaces: 1,
    parking_included: true,
    pets_allowed: false,
    pet_policy: 'No pets',
    min_stay_days: 30,
    max_stay_days: 270,
    base_amount: 1650,
    total_monthly_cost: 1920,
    utilities_cost: 160,
    electricity_cost: 60,
    internet_cost: 50,
    security_deposit: 1200,
    cleaning_fee: 100,
    deposit_months: 1,
    internet_speed: 'DSL/Cable internet',
    internet_included: false,
    electricity_included: false,
    live_walkthrough_enabled: false,
    virtual_tour_url: '',
  },
  {
    id: 'sample-stuttgart-large-family',
    title: 'Stuttgart 3BR Family Home — Opens in 2 Weeks',
    owner_id: 'sample-owner-5',
    owner_name: 'EUCOM Area Properties',
    location_id: 'sample-stuttgart',
    location_name: 'Stuttgart',
    location_lat: 48.7758,
    location_lng: 9.1829,
    location_coordinate_source: 'LOCATION_CENTER',
    region: 'Baden-Wuerttemberg',
    nearby_bases: ['Patch Barracks', 'Kelley Barracks'],
    hero_photo_url: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1200&h=800&fit=crop',
    photos: [
      { url: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1200&h=800&fit=crop', category: 'EXTERIOR' },
      { url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop', category: 'LIVING_ROOM' },
      { url: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&h=800&fit=crop', category: 'KITCHEN' },
    ],
    photo_count: 14,
    bedrooms: 3,
    bathrooms: 2,
    sqm: 128,
    tla_status: 'eligible',
    tla_eligible: true,
    availability_status: 'COMING_SOON',
    available_from: relDate(15),
    days_until_available: daysFrom(15),
    availability_confidence: 'HIGH',
    last_confirmed_at: relDate(-1),
    is_early_access: true,
    auto_deactivated: false,
    amenities: ['Garden', 'Garage', 'High-speed internet', 'Washer / dryer', 'Basement storage'],
    avg_rating: 4.8,
    review_count: 9,
    description: 'Spacious family home in the Stuttgart suburbs, within 15 minutes of Patch Barracks. Three full bedrooms with a child-safe garden and covered garage. Strong for families who need space and quiet. Current tenant departs in 2 weeks — owner prefers to lock in the next family early.',
    property_type: 'Semi-detached house',
    floor: 'Ground + first floor',
    year_built: 2008,
    last_renovated: 2022,
    kitchen_type: 'Open-plan family kitchen',
    heating_type: 'Central heating',
    energy_rating: 'B',
    parking_type: 'Attached garage',
    parking_spaces: 1,
    parking_included: true,
    pets_allowed: true,
    pet_policy: 'Dogs and cats welcome',
    min_stay_days: 30,
    max_stay_days: 365,
    base_amount: 2290,
    total_monthly_cost: 2640,
    utilities_cost: 200,
    electricity_cost: 80,
    internet_cost: 70,
    security_deposit: 1700,
    cleaning_fee: 160,
    deposit_months: 1,
    internet_speed: 'Fiber-ready internet',
    internet_included: false,
    electricity_included: false,
    live_walkthrough_enabled: true,
    virtual_tour_url: '',
  },
  {
    id: 'sample-vilseck-studio-available',
    title: 'Vilseck 1BR Flat — Ready Now, Single / Couple',
    owner_id: 'sample-owner-6',
    owner_name: 'Bavaria Relocation Rentals',
    location_id: 'sample-vilseck',
    location_name: 'Vilseck / Grafenwoehr',
    location_lat: 49.6136,
    location_lng: 11.8018,
    location_coordinate_source: 'LOCATION_CENTER',
    region: 'Bavaria',
    nearby_bases: ['Rose Barracks', 'Grafenwoehr Training Area'],
    hero_photo_url: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=1200&h=800&fit=crop',
    photos: [
      { url: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=1200&h=800&fit=crop', category: 'LIVING_ROOM' },
      { url: 'https://images.unsplash.com/photo-1505692952047-1a78307da8f2?w=1200&h=800&fit=crop', category: 'BEDROOM' },
    ],
    photo_count: 8,
    bedrooms: 1,
    bathrooms: 1,
    sqm: 52,
    tla_status: 'eligible',
    tla_eligible: true,
    availability_status: 'AVAILABLE',
    available_from: relDate(-3),
    days_until_available: 0,
    availability_confidence: 'HIGH',
    last_confirmed_at: relDate(-1),
    is_early_access: false,
    auto_deactivated: false,
    amenities: ['Compact kitchen', 'Fast Wi-Fi', 'On-street parking'],
    avg_rating: 4.5,
    review_count: 6,
    description: 'Compact and efficient furnished flat ideal for a single soldier or couple arriving without heavy household goods. Clean, well-lit, and within 10 minutes of Rose Barracks. Ready immediately with no waiting.',
    property_type: 'Furnished apartment',
    floor: '1st floor',
    year_built: 2003,
    last_renovated: 2021,
    kitchen_type: 'Compact kitchen',
    heating_type: 'Electric heating',
    energy_rating: 'C',
    parking_type: 'On-street parking',
    parking_spaces: 1,
    parking_included: false,
    parking_cost: 0,
    pets_allowed: false,
    pet_policy: 'No pets',
    min_stay_days: 30,
    max_stay_days: 180,
    base_amount: 1190,
    total_monthly_cost: 1390,
    utilities_cost: 120,
    electricity_cost: 50,
    internet_cost: 30,
    security_deposit: 900,
    cleaning_fee: 80,
    deposit_months: 1,
    internet_speed: 'Fast cable internet',
    internet_included: false,
    electricity_included: false,
    live_walkthrough_enabled: false,
    virtual_tour_url: '',
  },
];

export const sampleReviewsByListingId = {
  'sample-ramstein-command-home': [
    {
      id: 'sample-review-1',
      user_name: 'PCS Family - O6',
      rating: 5,
      review_text: 'Strong communication, clean handoff, and clear monthly costs. This felt designed for a real PCS move instead of a short-stay rental.',
    },
    {
      id: 'sample-review-2',
      user_name: 'Medical Relocation Client',
      rating: 5,
      review_text: 'Walkthrough was professional and the commute details were honest. Good example of the trust level clients ask for.',
    },
  ],
  'sample-stuttgart-officer-flat': [
    {
      id: 'sample-review-3',
      user_name: 'Dual-military household',
      rating: 4,
      review_text: 'Great location and polished presentation. We appreciated having timing and pricing clarity before inquiry.',
    },
  ],
  'sample-vilseck-ready-townhome': [
    {
      id: 'sample-review-4',
      user_name: 'Family with two children',
      rating: 5,
      review_text: 'Exactly the sort of ready-now property we wish more sites surfaced. Clear costs, strong photos, fast response.',
    },
  ],
  'sample-ramstein-reserved-apt': [
    {
      id: 'sample-review-5',
      user_name: 'NCO, PCS from CONUS',
      rating: 5,
      review_text: 'Owner was upfront that the unit was reserved and gave us a clear date. We locked it in early and had no surprises at handoff.',
    },
  ],
  'sample-stuttgart-large-family': [
    {
      id: 'sample-review-6',
      user_name: 'O4 family, 3 children',
      rating: 5,
      review_text: 'More space than we expected for the price. The garden was a huge win for the kids. Owner communicated every step clearly.',
    },
  ],
  'sample-vilseck-studio-available': [
    {
      id: 'sample-review-7',
      user_name: 'Single soldier, advance party',
      rating: 4,
      review_text: 'Exactly what I needed on short notice. Small but clean and well-stocked. Could walk to base in under 15 minutes.',
    },
  ],
};

export function findSampleListingById(listingId) {
  return sampleListings.find((listing) => listing.id === listingId) || null;
}
